import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ReferrerLoginPage = () => {
  const { referrer } = useParams();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [referrerInfo, setReferrerInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`/api/referrer/${referrer}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setReferrerInfo(data.referrer);
      });
  }, [referrer]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/referrer/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: referrer, password })
      });
      const data = await res.json();
      if (data.success && data.token) {
        localStorage.setItem(`ref_token_${referrer}`, data.token);
        navigate(`/ref/${referrer}/panel`);
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (err) {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #0e1633 0%, #1e2a4a 100%)' }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        {referrerInfo && (
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            {referrerInfo.logo_url && (
              <img src={referrerInfo.logo_url} alt={referrerInfo.name} style={{ width: 64, height: 64, objectFit: 'contain', borderRadius: 14, background: '#fff', boxShadow: '0 0 12px #2d6cff44', marginBottom: 10 }} />
            )}
            <div style={{ color: '#6ea8ff', fontWeight: 900, fontSize: '1.5rem', textShadow: '0 0 8px #2d6cffcc' }}>{referrerInfo.name}</div>
          </div>
        )}
        <form onSubmit={handleSubmit} style={{ background: '#182447', padding: '2.5rem 2rem', borderRadius: 16, boxShadow: '0 8px 32px #2d6cff33', minWidth: 340, maxWidth: 400, width: '100%' }}>
          <h2 style={{ color: '#6ea8ff', textAlign: 'center', marginBottom: 24 }}>Referrer Login</h2>
          <div style={{ marginBottom: 18 }}>
            <label style={{ color: '#b6d0ff', fontWeight: 600 }}>Username</label>
            <input value={referrer} disabled style={{ width: '100%', padding: '0.7rem', borderRadius: 8, border: '1px solid #2d6cff44', background: '#222e4d', color: '#b6d0ff', marginTop: 4, marginBottom: 8 }} />
          </div>
          <div style={{ marginBottom: 18 }}>
            <label style={{ color: '#b6d0ff', fontWeight: 600 }}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required style={{ width: '100%', padding: '0.7rem', borderRadius: 8, border: '1px solid #2d6cff44', background: '#222e4d', color: '#b6d0ff', marginTop: 4 }} />
          </div>
          {error && <div style={{ color: '#ff6b6b', marginBottom: 16, textAlign: 'center', fontWeight: 600 }}>{error}</div>}
          <button type="submit" disabled={loading} style={{ width: '100%', padding: '0.9rem', borderRadius: 8, background: '#2d6cff', color: '#fff', fontWeight: 700, fontSize: '1.1rem', border: 'none', boxShadow: '0 0 12px #2d6cff88', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ReferrerLoginPage; 